// @ts-check
/**
 * Convert if there is enriched data for given market or outcome
 * @param {String} name
 * @param {String} homeTeam
 * @param {String} guestTeam
 * @param {String} sbv
 */
export function checkEnrichedName(name, homeTeam, guestTeam, sbv) {
  let convertedName = name || '';

  return convertedName
    .replace(/{{HomeTeam}}/g, homeTeam || '')
    .replace(/{{AwayTeam}}/g, guestTeam || '')
    .replace(/{{SV}}/g, sbv || '');
}
/**
 * Check if there is enriched data for given market or outcome
 * @param {String} outcomeName
 */
export function containEnrichedName(outcomeName) {
  const enrichedRegex = /{{(HomeTeam|AwayTeam|SV)}}/g;

  return enrichedRegex.test(outcomeName);
}

/**
 * Returning the name of the folder where the silks are locaded
 * We form the name by getting the date from the first part of the jockeyFileName ex: 20220728gwo172003.png
 * And then format it from 20220728 to s280722 since everyday is uploaded a folder with the new date
 * @param {string} fileName - raw file name (eg. 20220728gwo172003.png)
 */
export function getHorseImgFolderName(fileName) {
  // Split the string into nonumber chunks and get the first chunk (date string)
  const fileDateName = fileName.split(/\D+/)[0] || '';
  // Get the date string matched into chunks of 2
  const dateChunks = fileDateName.match(/\d{2}/g) || [];
  // Finally remove the start of the year, reverse the order and get the final string
  const revertedDate = dateChunks.slice(1).reverse().join('');
  // If string exists insert s before the start otherwise return empty string
  return revertedDate ? `s${revertedDate}` : '';
}

/**
 * Replaces enriched name with home and away team names if applicable.
 * @param {string} name - The name to check for enrichment.
 * @param {string} homeTeam - The home team name.
 * @param {string} awayTeam - The away team name.
 * @param {string} sbv - The sbv name.
 * @returns {string} The enriched name if applicable, otherwise the original name.
 */
export function replaceEnrichedName(name, homeTeam, awayTeam, sbv) {
  return containEnrichedName(name) ? checkEnrichedName(name, homeTeam, awayTeam, sbv || '') : name;
}
/**
 * Extracts home and away teams from event name.
 * @param {string} eventName - The event name.
 * @returns {{ homeTeam: string, awayTeam: string }} Object containing home and away team names.
 * Empty strings if event name does not contain " vs ".
 */
export function extractTeams(eventName) {
  const regex = /\s+vs\s+/;

  if (!regex.test(eventName)) {
    return { homeTeam: '', awayTeam: '' };
  }

  // Split the eventName by the regex to get the home and away teams
  const [homeTeam, awayTeam] = eventName.split(regex);
  return { homeTeam: homeTeam.trim(), awayTeam: awayTeam.trim() };
}